export default function (request, reject, rootAddress) {
  var service = {};
  /**
    获取上传图片的token
    请求方法: GET, POST
    请求示例: http://<domain>/jxmobile2/nielian181210/get_upload_token?id=1&type=1

  响应示例: 

  {
      "code": 1,
      "status": 1,
      "msg": "",
      "message": "",
      "data": {
          "action": "http://up.qiniu.com",
          "input_file_name": "file",
          "input_values": {
              "token": "AUsWmwjd0VwZJP8mIH7jlMlR0Iy-YwqRGivBrYfp:fgtOon0UAEqK0cvrvg_QGy6nHCA=:eyJyZXR1cm5VcmwiOiIiLCJyZXR1cm5Cb2R5Ijoie30iLCJjYWxsYmFja0hvc3QiOiIiLCJjYWxsYmFja1VybCI6Imh0dHA6XC9cL3RhbS50dW5uZWwucXlkZXYuY29tXC9jb3JlXC91cGxvYWRcL3Fpbml1X2NhbGxiYWNrIiwiY2FsbGJhY2tCb2R5IjoiYnVuZGxlPWp4M3p0JmZpbGVfaWQ9MjQxNzE2ZDdhNGYzZTYzNTM3ODFlNDI2MTllYWRjOTcmZmlsZV9uYW1lPSQoZm5hbWUpJmZpbGVfc2l6ZT0kKGZzaXplKSZmaWxlX21pbWVfdHlwZT0kKG1pbWVUeXBlKSZmaWxlX2hhc2g9JChldGFnKSIsImluc2VydE9ubHkiOjEsImRldGVjdE1pbWUiOjEsImZzaXplTGltaXQiOjUyNDI4ODAsIm1pbWVMaW1pdCI6ImltYWdlXC9qcGVnO2ltYWdlXC9qcGVnO2ltYWdlXC9naWY7aW1hZ2VcL3BuZzt2aWRlb1wvbXA0O3ZpZGVvXC93ZWJtO3ZpZGVvXC9xdWlja3RpbWUiLCJzY29wZSI6Inhzamd3Omp4M3p0XC9qeDNcL2RtamgxNzExMzBcL2VkXC80N1wvZWQ0NzEzNGJmZDIxMjE5MmUxN2I4ZDI5NmMyMjRkOWIiLCJkZWFkbGluZSI6MTUxMjA0NzQ1OH0=",
              "key": "jx3zt/jx3/dmjh171130/ed/47/ed47134bfd212192e17b8d296c224d9b",
              "domain": "http://7xq4h6.com1.z0.glb.clouddn.com"
          },
          "session_id": "afebfbf476b36382386729cc6b7107da95e07eee",
          "request_id": "66fc148cd8529a531e99432b5d3a3d025205015a"
      }
   }
    */
  service.getUploadToken = function (id, type) {
    return request.jsonp(rootAddress + '/jxmobile2/nielian181210/get_upload_token', {
      id: id /*  作品序号(1, 2) */,
      type: type /*  上传类型 1成女 2萝莉 3正太 4成男 */
    }).then((response) => {
      if (response.status === 1 /* 成功 */) {
        /**
        {
          "data{}": {
            "auth_url": "微信授权地址(在需要微信授权的场景下会返回此字段)",
            "action": "上传地址",
            "input_file_name": "上传input:file的name名称",
            "input_values": "上传表单项"
          },
          "data{}.input_values{}": {
            "domain": "空间域名",
            "key": "上传文件KEY",
            "token": "上传文件TOKEN"
          }
        }
            */
        return response.data;
      }
      /**
      [{
        "code": "0",
        "description": "系统错误"
      }, {
        "code": "-10151",
        "description": "活动未开启"
      }, {
        "code": "-10152",
        "description": "活动配置错误"
      }, {
        "code": "-10153",
        "description": "活动未开始"
      }, {
        "code": "-10154",
        "description": "活动已结束"
      }, {
        "code": "-10701",
        "description": "未知驱动"
      }, {
        "code": "-10801",
        "description": "请先微信授权"
      }, {
        "code": "-20201",
        "description": "id不合法"
      }, {
        "code": "-20202",
        "description": "上传类型不合法"
      }]
          */
      return reject(response);
    });
  };

  service.test = function (id, type) {
    return request.jsonp('https://test-ssg-recruiting-api.seasungames.cn/api/ssg_recruiting_cn/v1/biz/get_current_user', {

    }).then((response) => {
      if (response.status === 1 /* 成功 */) {

        return response.data;
      }

      return reject(response);
    });
  };



  return service;
}